import React, { useState, useEffect, useContext } from 'react';
import i18n from '../../utils/i18n';
import CustomButton from './CustomButton';
import AffirmationDelete from './AffirmationDelete';
import IconTickWhite from '../../images/icon-tick-white.svg';
import IconPlusGrey from '../../images/icon-plus-grey.svg';
import IconTrashGrey from '../../images/icon-trash-grey.svg';
import InputContext from '../../context/inputContext';

const FooterBar = ({ onSave, addButtonActive, removeButtonActive }) => {
	const [openAffirmationDelete, setOpenAffirmationDelete] = useState(false);
	const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	const { isChanged, setIsChanged } = useContext(InputContext);
	useEffect(() => {
		const handleResize = () => setScreenWidth(window.innerWidth);
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const footerStyle =
		screenWidth < 480
			? {
					position: 'fixed',
					bottom: '0',
					right: '0',
					width: '100%',
					height: '68px',
					backgroundColor: '#fafcfe',
					borderTop: '1px solid #e3e5e9',
					display: 'flex',
					justifyContent:
						addButtonActive || removeButtonActive
							? 'space-between'
							: 'flex-end',
					alignItems: 'center',
					boxSizing: 'border-box',
					padding: '0 10px',
					gap: '8px',
			  }
			: {
					position: 'fixed',
					bottom: '0',
					right: '0',
					width: 'calc(100% - 12%)',
					maxWidth: 'calc(100% - 260px)',
					height: '68px',
					backgroundColor: '#fafcfe',
					borderTop: '1px solid #e3e5e9',
					display: 'flex',
					justifyContent:
						addButtonActive || removeButtonActive
							? 'space-between'
							: 'flex-end',
					alignItems: 'center',
					boxSizing: 'border-box',
					padding: '0 18px',
			  };

	const handleOpenAffirmationDelete = () => {
		setOpenAffirmationDelete(true);
	};

	return (
		<div style={footerStyle}>
			<>
				{addButtonActive && (
					<CustomButton
						buttonName={i18n.t('provider.addnewcompany')}
						iconSrc={IconPlusGrey}
						buttonColor='#fafcfe'
						hoverColor='#fafcfe'
						titleColor='#4b5080'
						titleHoverColor='#4b5080'
						width='220px'
						height='44px'
						padding='12px'
						borderColor='#e3e5e9'
						borderWidth='1px'
					/>
				)}
				{removeButtonActive && (
					<CustomButton
						buttonName={i18n.t('provider.deletecompany')}
						iconSrc={IconTrashGrey}
						buttonColor='#fafcfe'
						hoverColor='#fafcfe'
						titleColor='#4b5080'
						titleHoverColor='#4b5080'
						width='220px'
						height='44px'
						padding='12px'
						borderColor='#e3e5e9'
						borderWidth='1px'
						onClick={handleOpenAffirmationDelete}
					/>
				)}
				<CustomButton
					buttonName={i18n.t('general.save')}
					iconSrc={IconTickWhite}
					buttonColor='#1c32f3'
					hoverColor='#0036cc'
					titleColor='#ffffff'
					titleHoverColor='#e0e0e0'
					width='94px'
					height='44px'
					padding='12px'
					onClick={() => {
						onSave();
						setIsChanged(false);
					}}
				/>
				<AffirmationDelete
					openAffirmationDelete={openAffirmationDelete}
					setOpenAffirmationDelete={setOpenAffirmationDelete}
					title={i18n.t('provider.deletecompany')}
					subTitle={`${i18n.t(
						'provider.companydeletionaffirmation1'
					)} (-) ${i18n.t('provider.companydeletionaffirmation2')}`}
				/>
			</>
		</div>
	);
};

export default FooterBar;
